export default __webpack_public_path__ + "static/media/eye_close.e8473b4f.svg";